import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import allocateShippingUnitService from "services/allocateShippingUnitsService";

// List Allocate Shipping Unit
export const useListAllocateShippingUnit = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateShippingUnits"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["allocate-shipping-units", params?.page],
    () => allocateShippingUnitService.listAllocateShippingUnit(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("allocate_shipping_units"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useAllocateShippingUnitDetail = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateShippingUnits"]);
  const { addToast } = useToasts();

  return useQuery(
    ["allocate-shipping-units", "detail"],
    () => allocateShippingUnitService.allocateShippingUnitDetail(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.detail", {
                target: t("allocate_shipping_units"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return data;
      },
    }
  );
};

export const useUpdateAllocateShippingUnit = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateShippingUnits"]);
  const { addToast } = useToasts();

  return useMutation(allocateShippingUnitService.updateAllocateShippingUnit, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("allocate_shipping_units"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("allocate_shipping_units"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useInactiveAllocateShippingUnit = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateShippingUnits"]);
  const { addToast } = useToasts();

  return useMutation(allocateShippingUnitService.changeStatusAllocateShippingUnit, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.inactive", {
          target: t("allocate_shipping_units"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.inactive", {
              target: t("allocate_shipping_units"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useActiveAllocateShippingUnit = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateShippingUnits"]);
  const { addToast } = useToasts();

  return useMutation(allocateShippingUnitService.changeStatusAllocateShippingUnit, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.active", {
          target: t("allocate_shipping_units"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.active", {
              target: t("allocate_shipping_units"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useCreateAllocateShippingUnit = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["allocateShippingUnits"]);
  const { addToast } = useToasts();

  return useMutation(allocateShippingUnitService.createAllocateShippingUnit, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("allocate_shipping_units"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("allocate_shipping_units"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};